module.exports = __webpack_public_path__ + "img/sala_do_empreendedor_ouro.30f07e7a.png";